import { FC } from 'react';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import { Column } from './Column';
import styles from './styles.module.css';

export const Navigation: FC = () => {
  const { footer } = useSiteConfig();

  return (
    <div className={styles.grid}>
      {footer?.columns?.map((column) => (
        <Column key={column._uid} column={column} />
      ))}
    </div>
  );
};
